import Vue from 'vue'
import VueAMap from 'vue-amap'
import StarRating from 'vue-star-rating'
import Passed from '~/util/directives/passed'

Vue.component('star-rating', StarRating)
Vue.directive('passed', Passed)
Vue.use(VueAMap)
